import { useRetailer } from "@faire/retailer-visitor-shared/hooks/retailer/useRetailer";
import { useSettingMigrateRetailerStore } from "@faire/retailer-visitor-shared/settings/useSettingMigrateRetailerStore";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";

const useRetailerOpenWithFaireControl = () => {
  const { launchWithFaire } = useRetailerStore(["launchWithFaire"]);
  return { openWithFaire: launchWithFaire };
};

const useRetailerOpenWithFaireTreatment = () => {
  const { retailer } = useRetailer();
  const openWithFaire = retailer?.launch_with_faire;
  return { openWithFaire };
};

export const useRetailerOpenWithFaire = () => {
  const shouldUseHooksMigration = useSettingMigrateRetailerStore();
  if (shouldUseHooksMigration) {
    // eslint-disable-next-line react-compiler/react-compiler, react-hooks/rules-of-hooks
    return useRetailerOpenWithFaireTreatment();
  }
  // eslint-disable-next-line react-compiler/react-compiler, react-hooks/rules-of-hooks
  return useRetailerOpenWithFaireControl();
};
